import { randomNumber } from '../../../../utilities/randomNumber.util'
import { PnMedicationConstants } from './pnMedication.constants'
import { IAddPnMedication, IPnMedicationState, IPnMedicationsAction } from './pnMedication.types'

export const initialAddPnMedication = (): IAddPnMedication => {
  return {
    id: randomNumber(),
    key: randomNumber().toString(),
    medicationPNNV: null,
    medication: null,
    dose: null,
    doseUnit: null,
    doseUnitPNNV: null,
    route: null,
    routePNNV: null,
    rate: null,
    rateUnit: null,
    frequency: null,
    concentration: null,
    response: null,
    complications: [],
    wasted: false,
    lotNumber: '',
    witness1: '',
    witness2: '',
  }
}

export const initialPnMedicationState: IPnMedicationState = {
  medicationPNNV: null,
  medication: null,
  dose: null,
  doseUnit: null,
  doseUnitPNNV: null,
  route: null,
  routePNNV: null,
  key: randomNumber().toString(),
  date: '',
  time: '',
  pta: false,
  dateTime: '',
  assessedBy: null,
  rolePerforming: null,
  addToTimeline: false,
  pnMedication: null,
  addMedicationAdministeredData: [],
  rate: null,
  rateUnit: null,
  frequency: null,
  concentration: null,
  response: null,
  complications: [],
  authorization: null,
  wasted: false,
  lotNumber: '',
  witness1: '',
  witness2: '',
  comments: '',
  type: 'PnMedication',
}

export function pnMedicationReducer(
  state: IPnMedicationState = initialPnMedicationState,
  action: IPnMedicationsAction
): IPnMedicationState {
  switch (action.type) {
    case PnMedicationConstants.SET_MEDICATION_PNNV:
      return { ...state, medicationPNNV: action.medicationPNNV, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_MEDICATION:
      return { ...state, medication: action.medication, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_DOSE:
      return { ...state, dose: action.dose, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_DOSE_UNIT:
      return { ...state, doseUnit: action.doseUnit, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_DOSE_UNIT_PNNV:
      return { ...state, doseUnitPNNV: action.doseUnitPNNV, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_ROUTE:
      return { ...state, route: action.route, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_ROUTE_PNNV:
      return { ...state, routePNNV: action.routePNNV, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_KEY:
      return { ...state, key: action.key }
    case PnMedicationConstants.DELETE_PN_MEDICATION:
      return { ...state, pnMedication: action.pnMedication }
    case PnMedicationConstants.SET_TIME:
      return { ...state, time: action.time }
    case PnMedicationConstants.SET_ADD_TO_TIMELINE:
      return { ...state, addToTimeline: action.addToTimeline }
    case PnMedicationConstants.SET_DATE:
      return { ...state, date: action.date }
    case PnMedicationConstants.SET_DATE_TIME:
      return { ...state, time: action.time, date: action.date }
    case PnMedicationConstants.SET_PTA:
      return { ...state, pta: action.pta }
    case PnMedicationConstants.ADD_PN_MEDICATION:
      return {
        ...state,
        addMedicationAdministeredData: [...state.addMedicationAdministeredData, initialAddPnMedication()],
      }
    case PnMedicationConstants.SET_ADD_PN_MEDICATION_DATA:
      return {
        ...state,
        addMedicationAdministeredData: action.addMedicationAdministeredData,
      }
    case PnMedicationConstants.SET_STATE:
      return { ...action.pnMedicationState }
    case PnMedicationConstants.RESET_STATE:
      return {
        medicationPNNV: null,
        medication: null,
        dose: null,
        doseUnit: null,
        doseUnitPNNV: null,
        route: null,
        routePNNV: null,
        key: randomNumber().toString(),
        date: '',
        time: '',
        pta: false,
        dateTime: '',
        assessedBy: null,
        rolePerforming: null,
        addToTimeline: false,
        pnMedication: null,
        addMedicationAdministeredData: [],
        rate: null,
        rateUnit: null,
        frequency: null,
        concentration: null,
        response: null,
        complications: [],
        authorization: null,
        wasted: false,
        lotNumber: '',
        witness1: '',
        witness2: '',
        comments: '',
        type: 'PnMedication',
      }
    default:
      return state
  }
}
